module.exports = __webpack_public_path__ + "assets/d2c6a9d9b1c17256c0296e0fc7cb3e32.png";